(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class NolueArticleMemoryLike {
    constructor(button) {
      this.button = button;
      this.count = button.querySelector('[data-nolue-memory-count]');
      this.key = button.dataset.memoryKey;
      this.initialCount = Number(button.dataset.initialCount || 0);
      this.likeKey = 'nolue-memory-like:' + this.key;
      this.countKey = 'nolue-memory-count:' + this.key;
      this.init();
    }

    init() {
      const savedCount = Number(localStorage.getItem(this.countKey));
      const count = savedCount || this.initialCount;
      const liked = localStorage.getItem(this.likeKey) === 'true';
      this.count.textContent = count;
      this.button.classList.toggle('is-liked', liked);
      this.button.setAttribute('aria-pressed', liked ? 'true' : 'false');
      this.button.addEventListener('click', () => this.like());
    }

    like() {
      if (localStorage.getItem(this.likeKey) === 'true') {
        return;
      }
      const currentCount = Number(this.count.textContent || this.initialCount);
      const nextCount = currentCount + 1;
      this.count.textContent = nextCount;
      this.button.classList.add('is-liked');
      this.button.setAttribute('aria-pressed', 'true');
      localStorage.setItem(this.likeKey, 'true');
      localStorage.setItem(this.countKey, String(nextCount));
    }
  }

  function initNolueArticleMemoryLikes() {
    document.querySelectorAll('[data-nolue-memory-like]').forEach((button) => {
      if (button.dataset.memoryLikeReady === 'true') {
        return;
      }
      button.dataset.memoryLikeReady = 'true';
      new NolueArticleMemoryLike(button);
    });
  }

  document.addEventListener('DOMContentLoaded', initNolueArticleMemoryLikes);
  document.addEventListener('shopify:section:load', initNolueArticleMemoryLikes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolue-guangzhou-memory-room"] && !Shopify.designMode) return;
  try {
    
  class NolueMemoryRoomCarousel {
    constructor(card) {
      this.card = card;
      this.slides = Array.from(card.querySelectorAll('.nolue-memory-room__object-slide'));
      this.dots = Array.from(card.querySelectorAll('.nolue-memory-room__object-dots span'));
      this.index = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.init();
    }

    init() {
      if (this.slides.length <= 1) {
        return;
      }

      this.setActive(0);

      if (!this.reducedMotion && this.canHover) {
        this.card.addEventListener('mouseenter', () => this.start());
        this.card.addEventListener('mouseleave', () => this.stop());
        this.card.addEventListener('focusin', () => this.start());
        this.card.addEventListener('focusout', () => this.stop());
      }
    }

    setActive(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    start() {
      window.clearInterval(this.timer);
      this.timer = window.setInterval(() => {
        this.setActive((this.index + 1) % this.slides.length);
      }, 900);
    }

    stop() {
      window.clearInterval(this.timer);
      this.setActive(0);
    }
  }

  function initNolueMemoryRoomCarousels() {
    document.querySelectorAll('[data-memory-carousel]').forEach((card) => {
      if (card.dataset.memoryCarouselReady === 'true') {
        return;
      }
      card.dataset.memoryCarouselReady = 'true';
      new NolueMemoryRoomCarousel(card);
    });
  }

  document.addEventListener('DOMContentLoaded', initNolueMemoryRoomCarousels);
  document.addEventListener('shopify:section:load', initNolueMemoryRoomCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolue-journal"] && !Shopify.designMode) return;
  try {
    
  class NolueJournalMemoryLikes {
    constructor(button) {
      this.button = button;
      this.count = button.querySelector('[data-nolue-memory-count]');
      this.key = button.dataset.memoryKey;
      this.initialCount = Number(button.dataset.initialCount || 0);
      this.likeKey = 'nolue-memory-like:' + this.key;
      this.countKey = 'nolue-memory-count:' + this.key;
      this.init();
    }

    init() {
      const savedCount = Number(localStorage.getItem(this.countKey));
      const count = savedCount || this.initialCount;
      const liked = localStorage.getItem(this.likeKey) === 'true';
      this.count.textContent = count;
      this.button.classList.toggle('is-liked', liked);
      this.button.setAttribute('aria-pressed', liked ? 'true' : 'false');
      this.button.addEventListener('click', () => this.like());
    }

    like() {
      if (localStorage.getItem(this.likeKey) === 'true') {
        return;
      }
      const currentCount = Number(this.count.textContent || this.initialCount);
      const nextCount = currentCount + 1;
      this.count.textContent = nextCount;
      this.button.classList.add('is-liked');
      this.button.setAttribute('aria-pressed', 'true');
      localStorage.setItem(this.likeKey, 'true');
      localStorage.setItem(this.countKey, String(nextCount));
    }
  }

  function initNolueJournalMemoryLikes() {
    document.querySelectorAll('[data-nolue-memory-like]').forEach((button) => {
      if (button.dataset.memoryLikeReady === 'true') {
        return;
      }
      button.dataset.memoryLikeReady = 'true';
      new NolueJournalMemoryLikes(button);
    });
  }

  document.addEventListener('DOMContentLoaded', initNolueJournalMemoryLikes);
  document.addEventListener('shopify:section:load', initNolueJournalMemoryLikes);

  } catch(e) { console.error(e); }
})();
})();
